import React from "react";
import { Selection } from "../../components/SelfTest/Selection/Selection";

function SelfTest() {
  return <Selection />;
}

export { SelfTest };
